import styles from './HeartLoader.module.css';

export interface HeartLoaderProps {
  /** Size variant: 'sm' (40px), 'md' (120px default), 'lg' (160px) */
  size?: 'sm' | 'md' | 'lg';
  /** Show "Loading..." text below the heart */
  showText?: boolean;
  /** Custom loading text */
  text?: string;
  /** Fill entire viewport */
  fullScreen?: boolean;
  /** Additional class name */
  className?: string;
}

/**
 * Breathing Heart Loader
 *
 * A gentle, medically-themed loading indicator featuring the iCardio
 * anatomical heart logo with a subtle breathing animation and
 * pulsing blue halo effect.
 */
export default function HeartLoader({
  size = 'md',
  showText = false,
  text = 'Loading...',
  fullScreen = false,
  className,
}: HeartLoaderProps) {
  const containerClasses = [
    styles.container,
    styles[size],
    fullScreen && styles.fullScreen,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={containerClasses}>
      <div className={styles.heartWrapper}>
        <div className={styles.halo} />
        <img
          className={styles.heart}
          src="/assets/iCardio_Heart_only.svg"
          alt="Loading"
          draggable={false}
        />
      </div>
      {showText && <p className={styles.text}>{text}</p>}
    </div>
  );
}
